import React from 'react';
import { t } from '../../translations/translation.service'
import './index.css';

export default class Footer extends React.Component<any> {
  render() {
    return (
      <footer className="text-black mt-auto">
        <div className="bg-footer-1">
          <section className="container container-fluid padding-sec">
            <div className="row">
                <div className="col footer-col d-flex flex-column footer-elements">
                <header className="header-footer">
                  {t("Sobre nós")}
                </header>
                <blockquote className="blockquote">
                  <p className="mb-0">
                    {t("A Elumini é uma consultoria de TI com +20 anos de mercado, escritórios no Brasil, Portugal e EUA e olhar diferenciado para os seus colaboradores em todo o mundo.")}
                  </p>
                </blockquote>
              </div>
              <div className="col footer-col d-flex flex-column footer-elements">
                <header className="header-footer">
                  Great Place to Work®
                </header>
                <blockquote className="blockquote">
                  <p className="mb-0">
                    {t('A Elumini é certificada Great Place to Work® e desde 2011 está na lista das “Melhores Empresas para Trabalhar em TI”.')}
                  </p>
                </blockquote>
              </div>
              <div className="col footer-col d-flex flex-column footer-elements">
                <header className="header-footer">
                  {t("Desenvolvimento contínuo")}
                </header>
                <blockquote className="blockquote">
                  <p className="mb-0">
                    {t("Política formal de capacitação e certificações, acesso à plataforma Alura (PIPA) e HiPD — mentoria técnica para apoiar desafios do dia a dia.")}
                  </p>
                </blockquote>
              </div>
               <div className="col footer-col d-flex flex-column footer-elements">
                <header className="header-footer">
                  {t("Banco de Talentos")}
                </header>
                <blockquote className="blockquote">
                  <p className="mb-0">
                    {t("Ao cadastrar seu currículo no Enter, seu perfil passa a ficar no nosso radar para futuras oportunidades. Seus dados são tratados em conformidade com a LGPD.")}
                  </p>
                </blockquote>
              </div>
              <div className="col footer-col d-flex flex-column footer-elements">
                <ul className="list-unstyled mb-0 links-footer">
                  <li>
                    <a target="_blank" rel="noreferrer" href="https://www.elumini.com.br/empresa/" className="text-black-direita">
                      {t("Mais sobre a Elumini")}
                    </a>
                  </li>
                  <li>
                    <a href="/contact-us" className="text-black-direita">
                      {t("Fale Conosco")}
                    </a>
                  </li>
                  <li>
                    <a href="/terms-of-use" className="text-black-direita">
                      {t("Termos de Uso")}
                    </a>
                  </li>
                  <li>
                    <a href="/faq" className="text-black-direita">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="bg-footer-2 text-center p-3">Enter Elumini © 2021</div>
      </footer>
    );
  }
}
